<div
    class="navbar-option"
    (mouseenter)="showTooltip = true"
    (mouseleave)="showTooltip = false"
>
    <div class="dropdown">
        <div class="dropdown-toggle" (click)="toggleSound()">
            <img
                appImageSelector
                alt="mt-image"
                [imageType]="'icon'"
                [imageKey]="imageKey"
            />
        </div>
        <label
            *ngIf="showTooltip && imageKey.includes('off')"
            [attr.tooltip]="'sound-off' | lang"
            tooltip-position="left"
            class="label-tooltip"
        ></label>
        <label
            *ngIf="showTooltip && imageKey.includes('on')"
            [attr.tooltip]="'sound-on' | lang"
            tooltip-position="left"
            class="label-tooltip"
        ></label>
    </div>
</div>
